'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _aureliaFramework = require('aurelia-framework');

var _coreEs = require('@mojility/core-es6');

var _coach_http_client_factory = require('../util/coach_http_client_factory');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoachGateway = (_dec = (0, _aureliaFramework.inject)(_coach_http_client_factory.CoachHttpClientFactory), _dec(_class = function (_HttpGateway) {
  _inherits(CoachGateway, _HttpGateway);

  function CoachGateway(coachHttpClientFactory) {
    _classCallCheck(this, CoachGateway);

    return _possibleConstructorReturn(this, (CoachGateway.__proto__ || Object.getPrototypeOf(CoachGateway)).call(this, coachHttpClientFactory));
  }

  _createClass(CoachGateway, [{
    key: 'getVideoToken',
    value: function getVideoToken(secretKey) {
      return this.authenticatedGet(secretKey, 'conf/token');
    }
  }, {
    key: 'getWorkspaces',
    value: function getWorkspaces(secretKey) {
      return this.authenticatedGet(secretKey, 'client/workspaces');
    }
  }]);

  return CoachGateway;
}(_coreEs.HttpGateway)) || _class);
exports.default = CoachGateway;